import { render, staticRenderFns } from "./ConjugeLegado.vue?vue&type=template&id=fe407498&"
import script from "./ConjugeLegado.vue?vue&type=script&lang=js&"
export * from "./ConjugeLegado.vue?vue&type=script&lang=js&"
import style0 from "./ConjugeLegado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports